export const DISCOVERY_MODE_STEP_COMPLETED_MODAL = 'DISCOVERY_MODE_STEP_COMPLETED_MODAL';
export const DISCOVERY_PULSES_POST_PUBLISH_MODAL = 'DISCOVERY_PULSES_POST_PUBLISH_MODAL';